var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMfnxtLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1750,
    zoomAndPan: "magnify",
    viewBox: "0 0 1312.5 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "5524e0c0c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1146.414062 14.351562 L 1235.757812 14.351562 L 1235.757812 161.765625 L 1146.414062 161.765625 Z M 1146.414062 14.351562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c31d3fd821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1209 15 L 1300 15 L 1300 164 L 1209 164 Z M 1209 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "528a9f5428"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1301.449219 161.726562 L 1212.128906 163.738281 L 1208.8125 16.359375 L 1298.132812 14.351562 Z M 1301.449219 161.726562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9a9440ee1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1301.449219 161.726562 L 1212.128906 163.738281 L 1208.8125 16.359375 L 1298.132812 14.351562 Z M 1301.449219 161.726562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ea0303",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.067519, 273.78449)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 304.179688 0 L 269.117188 -227.242188 L 219.773438 -227.242188 L 158.09375 -87.648438 L 96.414062 -227.242188 L 47.394531 -227.242188 L 11.6875 0 L 61.679688 0 L 84.078125 -148.03125 L 151.925781 -0.324219 L 163.9375 -0.324219 L 231.785156 -148.03125 L 254.183594 0 Z M 304.179688 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ea0303",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.403435, 273.78449)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 161.664062 -181.46875 L 161.664062 -227.242188 L 25.96875 -227.242188 L 25.96875 0 L 74.988281 0 L 74.988281 -87 L 153.226562 -87 L 153.226562 -131.476562 L 74.988281 -131.476562 L 74.988281 -181.46875 Z M 161.664062 -181.46875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#0066cc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.018918, 283.539259)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 149.949219 -219.554688 C 120.914062 -219.554688 95.0625 -207.226562 78.753906 -188.132812 L 67.617188 -214.78125 L 27.84375 -214.78125 L 27.84375 0 L 85.914062 0 L 85.914062 -112.5625 C 85.914062 -147.164062 104.207031 -168.644531 134.039062 -168.644531 C 159.097656 -168.644531 171.429688 -153.132812 171.429688 -120.515625 L 171.429688 0 L 229.5 0 L 229.5 -130.0625 C 229.5 -184.554688 198.871094 -219.554688 149.949219 -219.554688 Z M 149.949219 -219.554688 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#0066cc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(738.855337, 283.539259)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 215.976562 0 L 142.390625 -112.960938 L 211.601562 -214.78125 L 147.960938 -214.78125 L 107.789062 -152.335938 L 70.796875 -214.78125 L 5.171875 -214.78125 L 73.183594 -110.175781 L 0.398438 0 L 64.433594 0 L 107.789062 -70.796875 L 150.347656 0 Z M 215.976562 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#0066cc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(955.52591, 283.539259)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 132.847656 -51.707031 C 111.367188 -51.707031 99.4375 -63.640625 99.4375 -84.320312 L 99.4375 -167.847656 L 157.90625 -167.847656 L 157.90625 -214.78125 L 98.640625 -214.78125 L 98.640625 -270.464844 L 87.503906 -270.464844 L 2.785156 -180.574219 L 2.785156 -167.847656 L 41.367188 -167.847656 L 41.367188 -76.367188 C 41.367188 -29.035156 70.402344 0 117.730469 0 L 159.097656 0 L 159.097656 -51.707031 Z M 132.847656 -51.707031 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5524e0c0c3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea0303",
    d: "M 1162.179688 13.96875 L 1235.742188 87.535156 L 1161.667969 161.605469 L 1146.605469 146.546875 L 1205.617188 87.535156 L 1147.117188 29.03125 L 1162.179688 13.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c31d3fd821)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#528a9f5428)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9a9440ee1f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0066cc",
    d: "M 1224.566406 15.625 L 1299.765625 87.515625 L 1227.378906 163.238281 L 1211.980469 148.519531 L 1269.648438 88.195312 L 1209.847656 31.023438 L 1224.566406 15.625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfnxtLogo);
export default __webpack_public_path__ + "static/media/mfnxt-logo.30bd0745fd6b52fc951146d8e4881ab5.svg";
export { ForwardRef as ReactComponent };